import Resources from "shared/actions/resourcesActions";

export default class CatalogResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "project_catalog", `/api/v1/project_catalogs`);
  }
}
